import Column from '@components/Column';
import styled from '@emotion/styled';
import useProject from '@hooks/useProject';
import { useTranslation } from 'react-i18next';

import PermissionItem from '../PermissionItem';

function PermissionList() {
    const { t } = useTranslation('permission');
    const project = useProject();
    return (
        <Container fullWidth spacing={18}>
            <PermissionItem name={t('deviceInfo.name')}>
                {t('deviceInfo.description')}
            </PermissionItem>
            <PermissionItem name={t('storage.name')}>
                {t('storage.description')}
            </PermissionItem>
            <PermissionItem name={t('notification.name')}>
                {t('notification.description')}
            </PermissionItem>
            <PermissionItem name={t('gps.name')}>
                {t('gps.description')}
            </PermissionItem>
            <PermissionItem name={t('phone.name')}>
                {t('phone.description')}
            </PermissionItem>
            {project?.features.inquiryEnabled && (
                <PermissionItem name={t('galleryCamera.name')}>
                    {t('galleryCamera.description')}
                </PermissionItem>
            )}
            {project?.features.giftEnabled && (
                <PermissionItem name={t('contacts.name')}>
                    {t('contacts.description')}
                </PermissionItem>
            )}
        </Container>
    );
}

const Container = styled(Column)`
    overflow: scroll;
    max-height: calc(100vh - 152px);
    padding-bottom: calc(96px + env(safe-area-inset-bottom));
`;

export default PermissionList;
